/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApi } from './base';

export const getCurrentTrimestre = () => `${baseUrlApi}/trimestres/current`;
export const clotureTrimestre = (identifiant: number) =>
  `${baseUrlApi}/trimestres/${identifiant}/cloture`;
export const declotureTrimestre = (identifiant: number) =>
  `${baseUrlApi}/trimestres/${identifiant}/decloture`;
export const getFirstYear = () => `${baseUrlApi}/trimestres/firstyear`;
export const getTrimestres = () => `${baseUrlApi}/trimestres?all=true`;
export const editionsTrimestre = (identifiant: number) =>
  `${baseUrlApi}/trimestres/${identifiant}/editions`;
